module.exports = __webpack_public_path__ + "media/3dmaxplugin2.eb8371f0.mp4";